import EffectMechanic from '@/roc/effects/EffectMechanic';
import AbstractProduction from '@/roc/effects/Production/AbstractProduction';
class PassiveProduction extends AbstractProduction {
    constructor(duration, output) {
        super(EffectMechanic.PASSIVE_PRODUCTION, duration, output);
    }
    clone(duration = null, output = null) {
        return new PassiveProduction(duration || this.__duration, output || this.__output);
    }
    production(level, era) {
        let amount = this.__output.calculate(level, era);
        amount = this.applyMods(amount);
        return {
            amount,
            duration: this.__duration.calculate(level, era),
        };
    }
}
export default PassiveProduction;
